<template>
  <div class="cardList-model">
    <div v-if="!doubleColShows" class="list-item list-item-model">
      <van-checkbox
        v-if="isCheckOpen"
        :name="item.id"
        shape="square"
        checked-color="#000"
      ></van-checkbox>
      <van-radio v-if="feedBackCheckOpen" :name="index"></van-radio>
      <div
        class="model"
        :class="isCheckOpen || feedBackCheckOpen ? 'model-294' : 'model-325'"
      >
        <div class="content">
          <div class="left" :style="item.imgUrl ? '' : 'background: #f3f4f5'">
            <img
              v-lazy="item.imgUrl ? item.imgUrl : ''"
              :src="item.imgUrl ? item.imgUrl : ''"
              alt=""
            />
          </div>
          <div class="right">
            <div class="top keywords-mark-f00" v-html="item.name || ''" />
            <div v-if="item.category === 'VSeries'" class="type">车系</div>
            <div v-if="item.category === 'VModel'" class="type">车型</div>
            <!-- <div class="time">发布时间：{{ item.time ? timeTypeFomate(item.time, 'YYYY-MM-DD') : '--' }}</div> -->
            <div class="time">发布时间：{{ item.modelYear || '--' }}</div>
            <div v-if="item.category === 'VModel'" class="btn" @click="!isCheckOpen && !feedBackCheckOpen && toDetailPage('modelDetail', item, index)">查看车型信息</div>
          </div>
        </div>
        <div v-if="item.modelNameList && item.modelNameList.length" class="model-list">
          <div v-for="(model, i) in item.modelNameList" :key="i" class="model-list-item" @click="updateKeyword(model)">
            {{ model }}
          </div>
        </div>
        <div class="card-bottom-wrapper">
          <div>
            <div v-if="item.category === 'VModel'" class="model-series">所属车系：{{ item.seriesName }}</div>
          </div>
          <span
            v-show="!isCheckOpen && !notInQw"
            @click.stop="
              share(item.category === 'VSeries' ? 'seriesDetail' : 'modelDetail', {
                ...item,
                offset:
                  (searchParams.pageIndex - 1) * searchParams.pageSize +
                  index +
                  1
              })
            "
          >
            <img
              style="width: 18px;height: 15px;"
              :src="proj === 'audi' ? audiSendIcon : sendIcon"
              alt=""
            />转发
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { getUrlParamsObj } from '@/scripts/utils'
import sendIcon from '@/assets/img/vSearch/icon_share.png'
import audiSendIcon from '@/assets/img/vSearch/send_icon.png'

export default {
  name: 'Media',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: () => {}
    },
    doubleColShows: {
      type: Boolean,
      default: false
    },
    isCheckOpen: {
      type: Boolean,
      default: false
    },
    feedBackCheckOpen: {
      type: Boolean,
      default: false
    },
    searchParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sendIcon,
      audiSendIcon,
      notInQw: false,
      proj: process.env.VUE_APP_PROJ
    }
  },
  created() {
    this.notInQw = getUrlParamsObj().notInQw || ''
  },
  mounted() {
    if (document.querySelectorAll('#tags')) {
      document.querySelectorAll('#tags').forEach(item => {
        item.addEventListener(
          'touchmove',
          function(event) {
            event.stopPropagation()
          },
          true
        )
      })
    }
  },
  methods: {
    getDurationFormat(duration) {
      if (!duration) return '--:--'
      const second = duration % 60
      const minute = parseInt(duration / 60) % 60
      const hour = parseInt(duration / 60 / 60)
      return `${hour > 9 ? hour : '0' + String(hour)}:${
        minute > 9 ? minute : '0' + String(minute)
      }:${second > 9 ? second : '0' + String(second)}`
    },
    timeTypeFomate(date, type = 'YYYY-MM-DD HH:mm:ss') {
      if (new Date(date).getDate() === new Date().getDate()) {
        return '今日发布'
      }
      else if (
        new Date().getTime() - new Date(date).getTime() <=
        7 * 24 * 60 * 60 * 1000
      ) {
        const dayNum = Math.ceil(
          (new Date().getTime() - new Date(date).getTime()) /
            (24 * 60 * 60 * 1000)
        )
        console.log(dayNum)
        return `${dayNum}天前`
      }
      else {
        return moment(new Date(Number(date))).format(type)
      }
    },

    toDetailPage(pathName, item, index) {
      item.offset = (this.searchParams.pageIndex - 1) * this.searchParams.pageSize + index + 1
      this.$emit('toDetailPage', pathName, item, index)
    },
    share(pathName, item) {
      this.$emit('share', pathName, item)
    },
    updateKeyword(keyWord) {
      this.$emit('updateKeyword', keyWord)
    }
  }
}
</script>
<style lang="less" scope>
.list-item-model {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .model-294 {
    width: 90%;
    transition-duration: 0.1s;
  }
  .model-325 {
    width: 100%;
    transition-duration: 0.1s;
  }
  .van-checkbox {
    width: 16px;
    .van-checkbox__icon {
      .van-icon {
        border-color: rgba(0, 0, 0, 0.5);
        width: 16px;
        height: 16px;
        line-height: 16px;
      }
      .van-icon::before {
        font-size: 12px;
        position: relative;
        top: -2px;
      }
    }
    .van-checkbox__label {
      display: none;
    }
  }
  .van-radio {
    width: 16px;
    .van-radio__icon {
      .van-icon {
        border-color: rgba(0, 0, 0, 0.5);
        width: 16px;
        height: 16px;
        line-height: 16px;
      }
      .van-icon::before {
        font-size: 12px;
        position: relative;
        top: -2px;
      }
    }
    .van-radio__icon--checked .van-icon {
      background-color: #000;
    }
    .van-radio__label {
      display: none;
    }
  }
}
.model {
  position:relative;
  .content {
    display: flex;
    .left {
      min-width: 120px;
      max-width: 120px;
      min-height: 80px;
      max-height: 80px;
      background-size: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-right: 15px;
      img {
        width: 100%;
      }
    }
    .right {
      width: calc(100% - 140px);
      .top {
        // height: 21px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 13px;
        color: #040404;
        margin-bottom: 5px;
        max-width: 90%;
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .type {
        height: 17px;
        margin-bottom: 5px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #9A9A9A;
      }
      .time {
        height: 17px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #9A9A9A;
      }
      .btn {
        margin-top: 5px;
        height: 17px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #006EFF;
      }
      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 10px;
        color: #999999;
        line-height: 16px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .model-list {
    margin-top: 12px;
    display: flex;
    align-items: center;
    width: 100%;
    overflow-x: auto;
    .model-list-item {
      background: #F0F1F3;
      box-sizing: border-box;
      margin-right: 15px;
      padding: 5px 10px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      white-space: nowrap;
    }
  }
  .card-bottom-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    .model-series {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
    }
    .bottom {
      font-family: DFPKingGothicGB-Regular;
      font-size: 10px;
      color: #999999;
      line-height: 16px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    span {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #040404;
      letter-spacing: 0;
      text-align: center;
      display: flex;
      align-items: center;
      img {
        margin-right: 4px;
      }
    }
  }
}
</style>
